import { render, staticRenderFns } from "./RightToolBar.vue?vue&type=template&id=bf8d7b5e&scoped=true"
import script from "./RightToolBar.vue?vue&type=script&lang=js"
export * from "./RightToolBar.vue?vue&type=script&lang=js"
import style0 from "./RightToolBar.vue?vue&type=style&index=0&id=bf8d7b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8d7b5e",
  null
  
)

export default component.exports